import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// In-memory token — httpOnly cookies are the primary auth. This is a fallback
// only when cross-site cookies are blocked (some browser privacy modes).
// Deliberately NOT persisted to localStorage/sessionStorage to reduce XSS surface.
let accessToken = null;

export function setAccessToken(token) {
  accessToken = token || null;
}

export function getAccessToken() {
  return accessToken;
}

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  if (accessToken) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

// Global 402 handler — any Pro-gated endpoint that responds with Payment
// Required fires a window event so `UpgradeBanner` can show a persistent
// upgrade CTA (much friendlier than a raw toast).
function _detectProFeature(url) {
  if (!url) return "This feature";
  if (url.includes("/reports/") || url.includes("/reports?")) return "Reports";
  if (url.includes("/worksites")) return "Worksites";
  if (url.includes("/workflow") || url.includes("/office-manager")) return "AI Office Manager";
  if (url.includes("/tax-documents") || url.includes("year-end")) return "Year-End Prep";
  if (url.includes("/billing/") || url.includes("/remote/")) return "Client Billing & Remote";
  return "This feature";
}

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 402) {
      const url = err?.config?.url || "";
      const feature = _detectProFeature(url);
      const message = err?.response?.data?.detail || "Upgrade to the Professional plan to unlock.";
      try { window.dispatchEvent(new CustomEvent("pro-required", { detail: { feature, message } })); }
      catch (e) { console.warn("pro-required event dispatch failed:", e); }
    }
    return Promise.reject(err);
  },
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  return typeof detail === "object" && detail.msg ? detail.msg : JSON.stringify(detail);
}

export function fmtMoney(n) {
  const num = Number(n || 0);
  return num.toLocaleString("en-US", { style: "currency", currency: "USD" });
}
